<template>
  <div class="w1200">
    <div class="a_nav">
      <el-badge :value="countResource" class="a_n_item" v-if="showResource">
        <router-link to="/audit/examine">
          <el-button class="a_n_btn" size="small" :type="$route.name=='auditExamine'?'primary':''">资源中心</el-button>
        </router-link>
      </el-badge>
      <el-badge :value="countThird" class="a_n_item" v-if="showThird">
        <router-link to="/audit/classroomAudit">
          <el-button class="a_n_btn" size="small" :type="($route.name=='auditClassExamine'||$route.name=='auditClassroom')?'primary':''">三师课堂</el-button>
        </router-link>
      </el-badge>
    </div>
    <div class="a_content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "audit",
  data() {
    return {
      countResource: "", //资源
      countThird: "", //三师
    };
  },
  computed: {
    ...mapState(["userModule"]),
    showResource() {
      let roleCode = this.userModule.roles.map((item) => item.roleCode);
      if (
        roleCode.includes("Admin") ||
        roleCode.includes("AreaManager") ||
        roleCode.includes("Auditor")
      ) {
        return true;
      }
      return false;
    },
    showThird() {
      let roleCode = this.userModule.roles.map((item) => item.roleCode);
      if (
        roleCode.includes("Admin") ||
        roleCode.includes("AreaManager") ||
        roleCode.includes("ThirdResourceManager")
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    console.log(this.$route.path);
    this.$ajax
      .post("/server/third/resource/approval/count/toAudit")
      .then((res) => {
        this.countResource = res.countResource;
        this.countThird = res.countThird;
      });
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, form) {
        if (to.name == "audit") {
          if (this.showResource) {
            this.$router.push({
              path: "/audit/examine",
            });
          } else {
            this.$router.push({
              path: "/audit/classroomAudit",
            });
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.a_nav {
  background-color: #fff;
  padding: 15px 15px 0;
  margin: 20px 0;
}
.a_n_item {
  margin-right: 30px;
}
.a_n_btn {
  border: none;
  border-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/page/audit/layout.vue